export async function publishSite(siteId: string) {
  const response = await fetch(`/api/sites/${siteId}/publish`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  });

  if (!response.ok) {
    const data = await response.json().catch(() => ({ error: "Publish failed" }));
    throw new Error(data.error || "Publish failed");
  }

  return response.json();
}
